<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N4R0nG/tc-custom/9781449423902.jpg?1737750951161" alt="This image is the cover for the book Pocket Posh 100 Classic Love Poems"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pocket Posh 100 Classic Love Poems
      </h1>
      <p class="bookDescription body article font2">
        <b>Find a hundred ways to say “I love you” with a heartwarming collection featuring poets from Shakespeare to Shelley. </b><br/><br/><i>“If ever two were one, then surely we.” —Anne Bradstreet</i><br/><br/>Shakespeare’s sonnets; the elegant words of Robert Browning; the poignant works of Elizabeth Barrett Browning; the stirring poetry of Christina Rossetti—all are collected here in this celebration of romantic passion and deep abiding love. <br/><br/>Emily Dickinson, Ralph Waldo Emerson, William Butler Yeats, Lord Byron, Keats, Wordsworth, Shelley, and other treasured poets provide meaningful, memorable ways to speak the language of the heart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Fox
      </h2>
      
      <p class="authorDescription body article">Jennifer Fox is a writer, reader, and lover of all types of poetry. She is a free spirit, music lover, peace seeker, traveler, and yoga instructor. Jennifer lives in Albuquerque, New Mexico, with her husband, rescued basset hounds, and geriatric cats.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50f6493c